import React from "react";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";

import history from "../src/utils/history";
import App from "./App";
import { StaticFallBack } from "../src/components/atoms/StaticFallback";
import { AuditoryProvider } from "./auditory/provider";
import { viewsModel } from "./models/views.models";
import Store from "./redux/store";
import config from "./utils/awsConfig";
import AppContext from "@context";

import "./styles/styles.scss";

const searchLocation = window.location.search;
const urlParams = new URLSearchParams(searchLocation);
const keyVersion = urlParams.get("version");

sessionStorage.setItem("version", keyVersion);
localStorage.setItem("environment", "DEV");
config.amplifyConfig();

ReactDOM.render(
  <AppContext.Provider value={viewsModel}>
    <AuditoryProvider fallback={StaticFallBack}>
      <Provider store={Store}>
        <Router history={history}>
          <App history={history} />
        </Router>
      </Provider>
    </AuditoryProvider>
  </AppContext.Provider>,
  document.getElementById("root")
);
